import { useNominationForm } from '@percent/grants-nomination-form/hooks';
import { Layout } from '@percent/grants-nomination-form/ui';
import { AnimatedContainer, Flex, Icon, Typography } from '@percent/lemonade';
import { Trans, useTranslation } from 'react-i18next';
import { useNavigate } from 'react-router-dom';
import styles from './SubmissionError.module.scss';

export const SubmissionError = () => {
  const { t } = useTranslation();
  const { nominationFormState } = useNominationForm();
  const navigate = useNavigate();

  if (nominationFormState !== 'application-error' && nominationFormState !== 'nomination-error') {
    navigate('/');
  }

  return (
    <Layout>
      <Flex className={styles.errorWrapper}>
        <AnimatedContainer>
          <Flex className={styles.errorIconWrapper}>
            <Icon name="close" size={10} color="alert400" />
          </Flex>
        </AnimatedContainer>
        <Typography variant="h2">{t('typography.submissionErrorTitle')}</Typography>
        <Typography variant="h3">
          <Trans
            i18nKey="typography.submissionErrorDescription"
            components={{
              a: (
                <a href={`mailto:${t('typography.helpEmail')}`} className={styles.emailLink}>
                  {t('typography.helpEmail')}
                </a>
              ),
            }}
          />
        </Typography>
      </Flex>
    </Layout>
  );
};
